import { create } from "zustand";
import { persist } from "zustand/middleware";

interface User {
  id: string;
  name: string;
  email: string;
  plan: "free" | "pro";
}

interface ChatTurn {
  id: string;
  role: "user" | "assistant";
  content: string;
  adapter?: string;
  timestamp: number;
}

interface SessionState {
  user: User | null;
  chat: ChatTurn[];
  voiceEnabled: boolean;
  avatarEnabled: boolean;
  preferredVoiceId: string;
  signIn: (user: User) => void;
  signOut: () => void;
  appendTurn: (turn: Omit<ChatTurn, "id" | "timestamp">) => void;
  clearChat: () => void;
  toggleVoice: () => void;
  toggleAvatar: () => void;
  setVoice: (id: string) => void;
}

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      user: null,
      chat: [],
      voiceEnabled: true,
      avatarEnabled: true,
      preferredVoiceId: "rachel",
      signIn: (user) => set({ user }),
      signOut: () => set({ user: null, chat: [] }),
      appendTurn: (turn) =>
        set((s) => ({
          chat: [
            ...s.chat,
            {
              ...turn,
              id: (() => { try { return crypto.randomUUID(); } catch { return Math.random().toString(36).slice(2); } })(),
              timestamp: Date.now(),
            },
          ].slice(-200),
        })),
      clearChat: () => set({ chat: [] }),
      toggleVoice: () => set((s) => ({ voiceEnabled: !s.voiceEnabled })),
      toggleAvatar: () => set((s) => ({ avatarEnabled: !s.avatarEnabled })),
      setVoice: (id) => set({ preferredVoiceId: id }),
    }),
    { name: "gslm-session" },
  ),
);
